import {
  getAsyncSelectShowSelectedApiParamIdPK,
  InputMultiSelectControl,
  MultiSelect,
} from '../../Select'
import { FlatSelect } from '../FlatSelect'

import { FLAT_MULTI_SELECT_DROPDOWN_FLOATING_CONFIG_SELECT_ALL } from './FlatMultiSelect.constants'

import FlatIcon from '../../../icons/flat.svg'

function FlatMultiSelect({
  Control = InputMultiSelectControl,
  dropdownFloatingConfig = FLAT_MULTI_SELECT_DROPDOWN_FLOATING_CONFIG_SELECT_ALL,
  getShowSelectedApiParam = getAsyncSelectShowSelectedApiParamIdPK,
  tagsProps,
  onClear,
  onSelectItem,
  ...restProps
}) {
  return (
    <MultiSelect
      {...restProps}
      Control={Control}
      EntityIcon={FlatIcon}
      Select={FlatSelect}
      dropdownFloatingConfig={dropdownFloatingConfig}
      getShowSelectedApiParam={getShowSelectedApiParam}
      tagsProps={{
        ...tagsProps,
        onChange: onSelectItem,
        onClear,
      }}
      onClear={onClear}
      onSelectItem={onSelectItem}
    />
  )
}

export default FlatMultiSelect
